import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col lg={4} className="brand-section">
            <div className="footer-brand">
              <h3>Arges Expres</h3>
              <p>Imobiliare TI&LU</p>
            </div>
          </Col>
          
          <Col lg={4} className="social-section">
            <div className="social-links">
              <a 
                href="https://facebook.com/argesexpres" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a 
                href="https://instagram.com/argesexpres" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a 
                href="https://tiktok.com/@argesexpres" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
              >
                <FontAwesomeIcon icon={faTiktok} />
              </a>
            </div>
          </Col>

          <Col lg={4} className="copyright-section">
            <p className="copyright">
              © {currentYear} Arges Expres Imobiliare TI&LU. Toate drepturile rezervate.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;